module.exports = __webpack_public_path__ + "static/media/ledabg.e9bdfa1e.png";